"use client";

import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export function ListingCardSkeleton() {
  return (
    <Card className="group relative overflow-hidden transition-all hover:shadow-md">
      <CardHeader className="p-0">
        <div className="aspect-[4/3] overflow-hidden">
          <Skeleton className="h-full w-full" />
        </div>
      </CardHeader>
      <CardContent className="p-4">
        <Skeleton className="mb-2 h-[28px] w-[85%]" />{" "}
        {/* Match text-lg font-semibold */}
        <Skeleton className="mb-3 h-[20px] w-[70%]" /> {/* Match text-sm */}
        <div className="mb-3">
          <Skeleton className="h-[32px] w-[120px]" /> {/* Match Badge size */}
        </div>
      </CardContent>
      <CardFooter className="flex justify-between border-t p-4">
        <div className="flex items-center gap-2">
          <Skeleton className="h-[24px] w-[60px]" /> {/* Match Badge size */}
          <Skeleton className="h-[20px] w-[100px]" /> {/* Match text-sm */}
        </div>
        <Skeleton className="h-8 w-8 rounded-full" /> {/* Match button size */}
      </CardFooter>
    </Card>
  );
}
